export default __webpack_public_path__ + "static/media/youtube.aebfee4c.webp";